import NavBar from "../../../components/NavBar";
import List from "../../../components/List";
import { hideAccount } from "../../../utils/utils";
import styled from "styled-components";
import { useState } from "react";
import { getInviternfo } from "../../../api";
import copy from "copy-to-clipboard";
import { Toast } from "antd-mobile";
import useWallet from "../../../hooks/Wallet/useWallet";
import { useEffect } from "react";
import { useIntl } from "react-intl";

export default function Invite() {
  const { myAccount } = useWallet();
  const [list, setList] = useState([]);
  const [statistic, setStatistic] = useState({
    level: 0,
    floor1: 0,
    total1: 0,
    activity1: 0,
    floor2: 0,
    total2: 0,
    activity2: 0,
  });
  const [loading, setLoading] = useState(true);
  const intl = useIntl();
  const headers = [
    {
      prop: "address",
      width: '30%',
      render: (val) => {
        return hideAccount(val);
      },
    },
    {
      prop: "level",
      width: '30%',
      render: (val, row) => {
        console.log(row);
        return val <= 0
          ? row.is_valid === 0
            ?intl.formatMessage({
              id:'pages.inviter.level_0'
            })
            : intl.formatMessage({
              id:'pages.inviter.level_1'
            })
          : intl.formatMessage({
            id:'pages.inviter.level_2'
          }, {
            level:val
          });;
      },
    },
    {
      prop: "floor",
      width: '30%',
      render: (val) => {
        return intl.formatMessage({
          id:'pages.inviter.floor'
        }, {
          floor:val
        });
      },
    },
   
  
    {
      width: '30%',
      prop: "is_valid",
      render: (val) => {
        return val ? '有效':'无效'
      },
    },
    {
      width: '30%',
      prop: "steps",
      render: (val) => {
        return val + '步';
      },
    },
    {
      width: '30%',
      prop: "create_time",
      render: (val) => {
        return val.split(" ")[0];
      },
    },
  ];
  const init = async () => {
    setLoading(true);
    const res = await getInviternfo(myAccount.account);

    const {
      level,
      floor1,
      total1,
      activity1,
      floor2,
      total2,
      activity2,
      list,
    } = res.data;
    setList(list);

    setStatistic({
      level,
      floor1,
      total1,
      activity1,
      floor2,
      total2,
      activity2,
    });
    setLoading(false);
  };

  useEffect(() => {
    if (myAccount) {
      init();
    }
  }, [myAccount]);

  return (
    <>
      <NavBar
        title={intl.formatMessage({
          id: "pages.inviter.title",
          defaultMessage: "邀請碼",
        })}
      ></NavBar>
      <Container>
        <Border>
          <div style={{ color: "#b8b2b2" }}>
            {intl.formatMessage({
              id: "pages.inviter.code",
              defaultMessage: "我的邀請碼",
            })}
          </div>
          <Text>
            {myAccount && myAccount.account && hideAccount(myAccount.account)}
          </Text>
          <Btn
            onClick={() => {
              copy(myAccount.account);
              Toast.show({
                content: intl.formatMessage({
                  id: "pages.inviter.copied",
                  defaultMessage: "復製成功！",
                }),
                icon: "success",
              });
            }}
          >
            {intl.formatMessage({
              id: "pages.inviter.copy",
              defaultMessage: "復製",
            })}
          </Btn>
        </Border>
        <div style={{marginBottom: '2.0rem'}}>
        <div>
          {intl.formatMessage({
            id:'pages.inviter.current_level'
          }, {
            floor:statistic.floor1,
            total:statistic.total1,
            activity:statistic.activity1
          })}
         
        </div>

        {/* {statistic.level > 2 && statistic.level < 6 ? (
          <div >
          {intl.formatMessage({
            id:'pages.inviter.next_level'
          }, {
            floor:statistic.floor2,
            total:statistic.total2,
            activity:statistic.activity2
          })}
          </div>
       ) : null}  */}
        </div>
        <Text2 style={{ marginBottom: "2.0rem" }}>
          {intl.formatMessage({
            id: "pages.inviter.record",
            defaultMessage: "邀請記錄",
          })}
        </Text2>

        <List loading={loading} wrap={true} list={list} header={headers} />
      </Container>
    </>
  );
}

const Container = styled.div`
  padding: 2.0rem;
`;

const Text = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: .7rem;
  margin: 1.6rem 0;
  color: #000000;
  text-transform: uppercase;
`;

const Border = styled.div`
  box-shadow: 2px .25rem .0rem #000;
  border: 2px solid #000;
  border-radius: 2.2rem;
  text-align: center;
  padding: 2.5rem 0;
  margin-bottom: 2.5rem;
  font-style: normal;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 1.4rem;
  color: #969696;
`;

const Btn = styled.div`
  background: #ed7335;
  width: 15.7rem;
  border: .15rem solid #000;
  color: #fff;
  border-radius: 2.0rem;
  text-align: center;
  margin: auto;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 1.4rem;
  padding: .8rem 0;
  box-shadow: 1px 1px 0 0 #000;
`;

const Text2 = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 1.8rem;

  color: #000000;
`;
